export default {"src":"/_next/static/media/calendar-icon-white.0351de5e.svg","height":19,"width":19};